export const routes = (prefix=`reports`, pre=`patients`) => [
    {
        name: `${prefix}.${pre}.tb-screening-report.index`,
        path: `/${prefix}/${pre}/tb-screening-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.tb-screening-report.index`,
                PageDescription: "Patient Reports: TB Screening report",
            },
        },
    },
    
];